export default __webpack_public_path__ + "static/lozenge-dropdown-dont-2-light-06c7ac53e5ce700762e1e16ef9e5b13e6cc536c11cb1b3124040b01d386c9114.png";